// A styled native <select>, matched to the Input primitive. Native on
// purpose: it keeps keyboard, mobile and RTL behavior for free, and the slice
// needs nothing a listbox popover would add.
import * as React from 'react';

import { cn } from '@/lib/utils';

function NativeSelect({ className, ...props }: React.ComponentProps<'select'>) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        'flex h-12 w-full min-w-0 rounded-[11px] border border-input bg-transparent px-3 py-1 text-base transition-colors outline-none',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        // Options render on the page background in dark mode either way.
        '[&>option]:bg-background [&>option]:text-foreground',
        className,
      )}
      {...props}
    />
  );
}

export { NativeSelect };
